import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

const BankTransferBlueLogo = ({ containerSize, size, onClick }) => (
  <WithIconRounded
    round
    className="k-ds-bg-interactive-primary"
    containerSize={containerSize}
    onClick={onClick}
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={size} height={size} rx="24" fill="#005ECC" />
      <path
        d="M22.7501 23C22.3359 23 22.0001 23.3358 22.0001 23.75V25.25C22.0001 25.6642 22.3359 26 22.7501 26H24.2501C24.6643 26 25.0001 25.6642 25.0001 25.25V23.75C25.0001 23.3358 24.6643 23 24.2501 23H22.7501Z"
        fill="white"
      />
      <path
        d="M23.8526 15.989C23.5013 16.2085 23.3946 16.6712 23.6141 17.0225C23.8336 17.3738 24.2963 17.4805 24.6476 17.261L26.5001 16.1032V19.25H17.5001C16.6717 19.25 16.0001 19.9216 16.0001 20.75V28.25C16.0001 29.0784 16.6717 29.75 17.5001 29.75H19.0001V32.8968L17.1476 31.739C16.7963 31.5195 16.3336 31.6262 16.1141 31.9775C15.8946 32.3288 16.0013 32.7915 16.3526 33.011L19.3526 34.886C19.5958 35.038 19.9044 35.038 20.1476 34.886L23.1476 33.011C23.4989 32.7915 23.6056 32.3288 23.3861 31.9775C23.1666 31.6262 22.7039 31.5195 22.3526 31.739L20.5001 32.8968V29.75H29.5001C30.3285 29.75 31.0001 29.0784 31.0001 28.25V20.75C31.0001 19.9216 30.3285 19.25 29.5001 19.25H28.0001V16.1032L29.8526 17.261C30.2039 17.4805 30.6666 17.3738 30.8861 17.0225C31.1056 16.6712 30.9989 16.2085 30.6476 15.989L27.6476 14.114C27.4044 13.962 27.0958 13.962 26.8526 14.114L23.8526 15.989ZM20.5001 26.75C20.5001 26.3358 20.1643 26 19.7501 26C19.3359 26 19.0001 26.3358 19.0001 26.75V28.25H17.5001V20.75H26.5001V22.25C26.5001 22.6642 26.8359 23 27.2501 23C27.6643 23 28.0001 22.6642 28.0001 22.25V20.75H29.5001V28.25H20.5001V26.75Z"
        fill="white"
      />
    </svg>
  </WithIconRounded>
);

BankTransferBlueLogo.propTypes = {
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  size: PropTypes.number,
};

BankTransferBlueLogo.defaultProps = {
  containerSize: 48,
  onClick: null,
  size: 48,
};

export default BankTransferBlueLogo;
